import { createSlice } from '@reduxjs/toolkit'
import { ApplicationState, AppSchema, IApplicationWithUpdate } from '../types/Application'
import { UserRightType } from '../../../User'
import { fetchApp } from '../services/fetchApp'

const appInitValues: IApplicationWithUpdate = {
	userId: '',
	lastSecurityUpdate: '',
	applicationId: '',
	applicationName: '',
	state: ApplicationState._,
	creationDate: '',
	expirationDate: '',
	rights: {
		clients: UserRightType.NO_PERMISSION,
		licenses: UserRightType.NO_PERMISSION,
		products: UserRightType.NO_PERMISSION,
		instances: UserRightType.NO_PERMISSION,
		users: UserRightType.NO_PERMISSION
	}
}

const initialState: AppSchema = {
	cachedApp: appInitValues,
	appEditable: appInitValues,
	isLoading: false,
	error: ''
}

const appSlice = createSlice({
	name: 'application',
	initialState,
	reducers: {
		resetAppEditable: (state) => {
			state.appEditable = state.cachedApp
		},
		setExpirationDate: (state, action) => {
			state.appEditable.expirationDate = action.payload
		},
		setAppName: (state, action) => {
			state.appEditable.applicationName = action.payload
		},
		setClientsRights: (state, action) => {
			state.appEditable.rights.clients = action.payload
		},
		setProductsRights: (state, action) => {
			state.appEditable.rights.products = action.payload
		},
		setLicensesRights: (state, action) => {
			state.appEditable.rights.licenses = action.payload
		},
		setInstancesRights: (state, action) => {
			state.appEditable.rights.instances = action.payload
		},
		setUsersRights: (state, action) => {
			state.appEditable.rights.users = action.payload
		},
		setState: (state, action) => {
			state.appEditable.state = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchApp.pending, (state) => {
				state.isLoading = true
				state.appEditable = structuredClone(appInitValues)
				state.appEditable = structuredClone(appInitValues)
				state.error = ''
			})
			.addCase(fetchApp.fulfilled, (state, action) => {
				state.isLoading = false
				state.appEditable = action.payload
				state.cachedApp = action.payload
			})
			.addCase(fetchApp.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: appActions } = appSlice
export const { reducer: appReducer } = appSlice
